import { render, staticRenderFns } from "./indexDirector.vue?vue&type=template&id=a5318ba8&scoped=true"
import script from "./indexDirector.vue?vue&type=script&lang=js"
export * from "./indexDirector.vue?vue&type=script&lang=js"
import style0 from "./indexDirector.vue?vue&type=style&index=0&id=a5318ba8&lang=sass"
import style1 from "./indexDirector.vue?vue&type=style&index=1&id=a5318ba8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5318ba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5318ba8')) {
      api.createRecord('a5318ba8', component.options)
    } else {
      api.reload('a5318ba8', component.options)
    }
    module.hot.accept("./indexDirector.vue?vue&type=template&id=a5318ba8&scoped=true", function () {
      api.rerender('a5318ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexDirector.vue"
export default component.exports